export default __webpack_public_path__ + "static/media/dejan_m.4fe9b3b9.jpg";